import { InputFileField } from '@presentation/components';
import { FieldArray } from 'formik';
import type { FC } from 'react';
import { useMemo } from 'react';
import { FaPlus } from 'react-icons/fa';
import * as Styled from './styled';
import type { MtImagesArrayProps } from './types';

export const MtImagesArray: FC<MtImagesArrayProps> = (props) => {
  const { mode, values, log } = props;

  const images = values?.images;
  const filteredImages: Array<string | File> = useMemo(() => {
    if (!images) {
      return [];
    }
    return images.filter((element: string | File | undefined) => element);
  }, [images]);

  const imagesAmount: number = useMemo(() => {
    if (mode === 'view') return filteredImages.length;
    return filteredImages.length + 1;
  }, [filteredImages.length, mode]);

  return (
    <FieldArray name="images">
      {() => (
        <Styled.ImageContainer>
          {filteredImages.map((img) => {
            const index = images?.indexOf(img);
            return (
              <Styled.ImageWrapper key={index} imagesAmount={imagesAmount}>
                <InputFileField
                  name={`images[${index}]`}
                  accept="image/*, .heic, .heif"
                  disabled={mode === 'view'}
                  imageCropperProps={{
                    maxCompressedSize: 8 * 1000000,
                  }}
                  icon={<FaPlus />}
                  log={log}
                />
              </Styled.ImageWrapper>
            );
          })}
          {mode !== 'view' && (
            <Styled.ImageWrapper imagesAmount={imagesAmount}>
              <InputFileField
                name={`images[${images?.length}]`}
                accept="image/*, .heic, .heif"
                imageCropperProps={{
                  maxCompressedSize: 8 * 1000000,
                }}
                icon={<FaPlus />}
                log={log}
              />
            </Styled.ImageWrapper>
          )}
        </Styled.ImageContainer>
      )}
    </FieldArray>
  );
};
